module.exports = __webpack_public_path__ + "static/media/kanin-min.95dfdc45.png";